import { Actions, useGetAllActions } from '../services/react-query/permissions';

const usePermissionAllowed = (action: Actions): null | boolean => {
  const { data: permissions, isFetching: isGetAllActionsFetching } = useGetAllActions({ actions: [action] });
  if (isGetAllActionsFetching || !permissions) return null;

  return permissions[action];
};

export default usePermissionAllowed;
